// Swiper
import Swiper, { Navigation, Autoplay, Pagination } from "swiper";
import "swiper/css/bundle";
Swiper.use([Navigation, Pagination, Autoplay]);

const gallery = new Swiper(".gallery-swiper", {
  loop: true,
  spaceBetween: 6,
  grabCursor: true,
  centeredSlides: true,
  speed: 800,
  breakpoints: {
    320: {
      slidesPerView: 1.2,
    },
    420: {
      slidesPerView: 1.5,
    },
    500: {
      slidesPerView: 1.8,
    },
    600: {
      slidesPerView: 2.1,
    },
    769: {
      slidesPerView: 5,
    },
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
